import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Header from './UI.Header';
import Footer from './UI.footer';
import Error from './UI.Error';
import { withRouter } from 'kts-platform-frame/routes';
import { document } from 'src/api';
import invoiceCompared from './invoiceCompared';
import { PageMeta } from 'src/api/document/documentQuery/IData';
import { InvoiceTypeCodeMap, differenceCode } from './unit';
import {
    Card,
    Row,
    Col,
    Table,
    Pagination,
    Radio,
    Tooltip,
    Icon,
    Badge
} from 'antd';
import moment from 'moment';
import RefuseM from './UI.RefuseM';
import { Field } from 'kts-scaffold-framework/utils/doc';

const css = require('./index.scss');
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

class OwnState {
    detail: object = {};
    documentStatus: string = '';
    detailVisable: boolean = false;
    invoiceLineDetail: object = {};
    pageMeta: PageMeta = {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        total: 0,
    };
    diffComparisonResult: boolean = false;
    documentId: string = ''; // 对账单id
    comparisonDiffer: number = 0;
}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = new OwnState;
    }

    componentDidMount() {
        this.getDocumnetDetail();
    }

    render() {
        const columns = [
            {
                title: '',
                dataIndex: 'text',
                key: 'text',
                render: (text, record) => {
                    const { comparisonResult } = record;
                    let compareisonResultOK,
                        compareisonResultCode,
                        comparisonRule;
                    if (comparisonResult) {
                        const { comparisonResultList } = comparisonResult;
                        compareisonResultOK = comparisonResultList.some(ele => {
                            return ele.comparisonResult === true;
                        });
                        comparisonRule = comparisonResultList[0]['comparisonRule'];
                        if (comparisonRule === 1) {
                            compareisonResultCode = comparisonResultList[0]['marginValueSourceFieldName'];
                        } else if (comparisonRule === 2) {
                            compareisonResultCode = comparisonResultList[0]['marginRateSourceFieldName'];
                        }
                    }
                    if (compareisonResultOK) {
                        return <Tooltip title={`与匹配对账单${differenceCode[compareisonResultCode]}不一致`}><Icon type="fapiaoyichang" style={{ color: 'rgb(245, 34, 45)' }} /></Tooltip>;
                    }
                    return undefined;
                }
            },
            {
                title: '货物或应税劳务、服务名称',
                dataIndex: 'ItemName',
                key: 'ItemName',
                width: 200,
                render: (text, record) => record.Item.ItemName
            },
            {
                title: '规格型号',
                dataIndex: 'ItemModelName',
                key: 'ItemModelName',
                width: 90,
                render: (text, record) => record.Item.ItemModelName
            },
            {
                title: '数量',
                dataIndex: 'test4',
                key: 'test4',
                width: 60,
                render: (text, record) => record.Item.PackQuantity
            },
            {
                title: '单位',
                dataIndex: 'test5',
                key: 'test5',
                width: 60,
                render: (text, reocrd) => reocrd.Item.QuantityUnitCode.unitCode
            },
            {
                title: '单价',
                dataIndex: 'Price',
                key: 'Price',
                align: 'right' as any,
            },
            {
                title: '税率',
                dataIndex: 'test7',
                key: 'test7',
                width: 80,
                render: (text, record) => record.TaxTotal.TaxSubtotal.TaxCategory.Percent && `${record.TaxTotal.TaxSubtotal.TaxCategory.Percent.value}%`,
            },
            {
                title: '税额',
                dataIndex: 'test9',
                key: 'test9',
                render: (text, record) => record.TaxTotal.TaxSubtotal.TaxAmount && record.TaxTotal.TaxSubtotal.TaxAmount.value,
                align: 'right' as any,
            },
            {
                title: '金额（不含税）',
                dataIndex: 'LineExtensionAmount',
                key: 'LineExtensionAmount',
                align: 'right' as any,
            },
        ];
        const { detail, pageMeta, diffComparisonResult, documentID, comparisonDiffer } = this.state;
        let { AccountingCustomerParty, AccountingSupplierParty, LegalMonetaryTotal, Lines = [], diffComparisonLines } = detail;
        diffComparisonLines = diffComparisonLines || [];
        const documentUuid = this.props.match.params.id;
        console.log('status:' + this.state.documentStatus);
        return (
            <div className={css['index']}>
                <Header
                    id={this.props.match.params.id}
                    status={this.state.documentStatus === 'RECEIVED' ?
                        ['REJECTED', 'ACCEPTED'] :
                        this.state.documentStatus === 'DRAFT' ?
                            ['SEND'] : []}
                    update={this.getDocumnetDetail}
                />
                {
                    comparisonDiffer > 0 && <Error message={`当前发票有${comparisonDiffer}条发票行与原始交易不一致`} />
                }
                <div className={css['summary']}>
                    <Card
                        title="已关联交易单据"
                    >
                        <p><h6>对账单：</h6>{documentID}</p>
                    </Card>
                </div>
                <div className={css['detail']}>
                    <Card
                        title={this.detailTitle(detail)}
                        extra={<span className={css['detail-update-date']}>{`查验数据更新时间：${detail.CheckTime ? moment(detail.CheckTime).format('YYYY-MM-DD HH:mm:ss') : ''}`}</span>}
                    >
                        <Row className={css['detail-info']}>
                            <Col span={12}>
                                <p><h6>购买方：</h6>{AccountingCustomerParty && AccountingCustomerParty.PartyName}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>销售方：</h6>{AccountingSupplierParty && AccountingSupplierParty.PartyName}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>纳税人识别号：</h6>{AccountingCustomerParty && AccountingCustomerParty.PartyIdentification}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>纳税人识别号：</h6>{AccountingSupplierParty && AccountingSupplierParty.PartyIdentification}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>地址及电话：</h6>{AccountingCustomerParty && AccountingCustomerParty.PostalAddress}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>地址及电话：</h6>{AccountingSupplierParty && AccountingSupplierParty.PostalAddress}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>开户行及账号：</h6>{detail.PaymentMeans}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>开户行及账号：</h6>{AccountingSupplierParty && AccountingSupplierParty.FinancialAccount}</p>
                            </Col>
                        </Row>
                        <Row className={css['detail-info']} style={{ marginBottom: '0px' }}>
                            <Col span={10}>
                                <p><h6>发票号码：</h6>{detail.InvoiceNumber}</p>
                            </Col>
                            <Col span={10}>
                                <p><h6>发票代码：</h6>{detail.InvoiceCode}</p>
                            </Col>
                            <Col span={4}>
                                <p><h6>开票日期：</h6>{moment(detail.IssueDate).format('YYYY-MM-DD')}</p>
                            </Col>
                            <Col span={10}>
                                <p><h6>无税金额：</h6>{LegalMonetaryTotal && LegalMonetaryTotal.LineExtensionAmount}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>校验码：</h6>{detail.CheckCode}</p>
                            </Col>
                            <Col span={12}>
                                <p><h6>备注：</h6>{detail.Note}</p>
                            </Col>
                        </Row>
                        <Row className={css['detail-count']} type="flex" justify="space-between" align="middle">
                            <Col span={8}>
                                <h3>统计</h3>
                            </Col>
                            <Col span={16}>
                                <Row>
                                    <Col span={5}>
                                        <h6 className={css['detail-count-title']}>总税额</h6>
                                        <span className={css['detail-count-info']}>{LegalMonetaryTotal && LegalMonetaryTotal.TaxExclusiveAmount}</span>
                                    </Col>
                                    <Col span={5}>
                                        <h6 className={css['detail-count-title']}>总金额（不含税）</h6>
                                        <span className={css['detail-count-info']}>{LegalMonetaryTotal && LegalMonetaryTotal.LineExtensionAmount}</span>
                                    </Col>
                                    <Col span={5}>
                                        <h6 className={css['detail-count-title']}>价税合计</h6>
                                        <span className={css['detail-count-info']}>{LegalMonetaryTotal && LegalMonetaryTotal.TaxInclusiveAmount}</span>
                                    </Col>
                                    <Col span={9}>
                                        <h6 className={css['detail-count-title']}>价税合计（大写）</h6>
                                        <span className={css['detail-count-info']}>{LegalMonetaryTotal && Field.toStringChinese(LegalMonetaryTotal.TaxInclusiveAmount)}</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <div>
                            <div className={css['detail-tableHeader']}>
                                <h3>发票行</h3>
                                <RadioGroup onChange={this.condition} defaultValue={1}>
                                    <RadioButton value={1}>全部</RadioButton>
                                    <RadioButton value={2}>有差异</RadioButton>
                                </RadioGroup>
                            </div>
                            <div className={css['detail-table']}>
                                <Table
                                    className={"kts-app-ant-table-1"}
                                    columns={columns}
                                    dataSource={diffComparisonResult ? diffComparisonLines.slice((pageMeta.pageNum - 1) * pageMeta.pageSize, pageMeta.pageNum * pageMeta.pageSize) : Lines.slice((pageMeta.pageNum - 1) * pageMeta.pageSize, pageMeta.pageNum * pageMeta.pageSize)}
                                    pagination={false}
                                    expandedRowRender={record => invoiceCompared(record, documentUuid)}
                                    rowClassName={record => { return !record.comparisonResult && css['detail-table-row']; }}
                                />
                                <div className={css['detail-table-pagination']}>
                                    <Pagination
                                        size="small"
                                        total={pageMeta.total}
                                        pageSize={pageMeta.pageSize}
                                        onChange={this.pageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>
                    <Footer
                        id={this.props.match.params.id}
                        status={this.state.documentStatus === 'RECEIVED' ?
                            ['REJECTED', 'ACCEPTED'] :
                            this.state.documentStatus === 'DRAFT' ?
                                ['SEND'] : []}
                        update={this.getDocumnetDetail}
                    />
                    {this.modulesState.refuseM && <RefuseM />}
                </div>
            </div>
        );
    }

    private getDocumnetDetail = async () => {
        const documentUuid = this.props.match.params.id;
        const res = await document.invoiceDetail(this,
            {
                documentUuid,
                comparisonType: 'Invoice_Reconciliation',
            });
        if (!res.er) {
            const { documentContent = {}, documentStatus = '', comparisonDiffer = 0 } = res.res;
            const { Lines = [] } = documentContent;
            if (documentContent.ReconciliationSheetReference && documentContent.ReconciliationSheetReference.ID) {
                this.getDocumentId(documentContent.ReconciliationSheetReference.ID);
            }
            this.setState({
                detail: documentContent,
                documentStatus: documentStatus,
                comparisonDiffer,
                pageMeta: {
                    pageNum: 1,
                    pageSize: 10,
                    pages: 0,
                    total: Lines.length
                }
            });
        }
    }

    /** 专门获取对账单id */
    private getDocumentId = async (documentUuid: string) => {
        const res = await document.getDocumnetId(this, { documentUuid, documentCheck: false });
        if (!res.er) {
            const { documentID } = res.res;
            this.setState({
                documentID
            });
        }
    }

    private pageChange = (pageNum, pageSize) => {
        const Lines = this.state.detail.Lines;
        this.setState({
            pageMeta: {
                pageNum,
                pageSize,
                pages: 0,
                total: Lines.length
            }
        });
    }

    private detailTitle = (detail) => {
        if (!detail) {
            return;
        }
        const { documentStatus } = this.state;
        return (
            <div className={css}>
                {`${InvoiceTypeCodeMap.get(detail.InvoiceTypeCode)}: ${detail.ID}`}
                <div style={{ display: "inline-block", margin: "0px 12px" }}>
                    {
                        documentStatus === 'DRAFT' ? <Badge count="草稿" style={{ backgroundColor: '#d9d9d9' }} />
                            : documentStatus === 'SENT' ? <Badge count="发送" style={{ backgroundColor: '#1890ff' }} />
                                : documentStatus === 'RECEIVED' ? <Badge count="接收" style={{ backgroundColor: '#1890ff' }} />
                                    : documentStatus === 'ACCEPTED' ? <Badge count="接受" style={{ backgroundColor: '#52c41a' }} />
                                        : documentStatus === 'REJECTED' ? <Badge count={'拒绝'} />
                                            : documentStatus === 'CANCEL_REJECTED' ? <Badge count="拒绝作废" style={{ background: '#1890ff' }} />
                                                : documentStatus === 'CANCELED' ? <Badge count="已作废" />
                                                    : documentStatus === 'CANCEL_REQUESTING' ? <Badge count="申请作废" />
                                                        : undefined
                    }
                </div>
            </div>
        );
    }

    private condition = (val) => {
        let { Lines, diffComparisonLines } = this.state.detail;
        diffComparisonLines = diffComparisonLines || [];
        Lines = Lines || [];
        const value = val.target.value;
        if (value === 1) {
            this.setState({
                diffComparisonResult: false,
                pageMeta: {
                    pageNum: 1,
                    pageSize: 10,
                    pages: 0,
                    total: Lines.length,
                }
            });
        } else {
            this.setState({
                diffComparisonResult: true,
                pageMeta: {
                    pageNum: 1,
                    pageSize: 10,
                    pages: 0,
                    total: diffComparisonLines.length,
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/UI.Components.tsx